import React, { useContext } from "react";
import * as Sentry from "@sentry/react";
import { UI } from "@wwimmo/ui";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { RootStoreContext } from "src/stores/RootStore";
import { Route } from "src/config/routes";
import { useLocation } from "react-router-dom";
import styles from "./CopyUserBanner.module.css";

const CopyUserBannerBase = () => {
    const { t } = useTranslation();
    const { authStore, navStore } = useContext(RootStoreContext);
    const location = useLocation();

    const shouldRenderCopyUserBanner = authStore.isCopyUser && location.pathname.includes(Route.coowner);

    if (!shouldRenderCopyUserBanner) {
        return null;
    }

    return (
        <div className={`container-fluid ${styles.CopyUserBanner}`}>
            <UI.Row>
                <UI.Col xl={12} sm={12} className="d-flex align-items-center  mb-lg-0">
                    <div className={styles.CopyUserTitle}>
                        {t("screens.customer_users.copy")}: {navStore.customer.userName}
                    </div>
                    <div className={styles.CopyUserText}>{t("screens.customer_users.banner_text")}</div>
                    <UI.Button to={Route.logout} label={t("labels.logout")} />
                </UI.Col>
            </UI.Row>
        </div>
    );
};

export const CopyUserBanner = Sentry.withProfiler(observer(CopyUserBannerBase));
